<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="ali-modal u-window" :class="{'comfirm' : !(($store.state.userinfo.uflag & 256) == 256) && readonly , 'complete' : (($store.state.userinfo.uflag & 256) == 256)}">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title" :class="{'comfirm' : !(($store.state.userinfo.uflag & 256) == 256)&& readonly}"></h5>
                    
                    <div class="notice" v-if="!(($store.state.userinfo.uflag & 256) == 256)">
                        <div class="comfirm-info" v-if="readonly">
                            <p>【{{ form_data.realName }}】，身份证号码【{{ form_data.IdCard }}】</p>
                            <p>即将绑定支付宝账号【{{ form_data.aliPayAccount }}】</p>
                            <p>手机号码为【{{ form_data.mobile }}】</p>
                        </div>
                        <div class="form-info" v-else>请仔细填写您的对应支付宝账号和个人信息</div>
                    </div>
                    <div class="notice" v-else>{{ '【'+ form_data.realName +'】已绑定支付宝账号'}}</div>

                    <van-form>
                    <div class="form-view" v-show="!(($store.state.userinfo.uflag & 256) == 256) && !readonly || (($store.state.userinfo.uflag & 256) == 256)">
                        
                        <div class="from-item">
                            <van-field v-model="form_data.realName" label="真实姓名" placeholder="请输入真实姓名"
                            required
                            :readonly="readonly"/>
                        </div>
                        <div class="from-item">
                            <van-field v-model="form_data.aliPayAccount" label="支付宝账号" placeholder="请输入支付宝账号"
                            required
                            :readonly="readonly"/>                            
                        </div>
                        <p class="attention">*仅支持邮箱和手机号格式</p>
                        <div class="from-item">
                            <van-field v-model="form_data.IdCard" label="身份证号码" placeholder="请输入身份证号码"
                            required
                            :readonly="readonly"/>
                        </div>
                        <div class="from-item">
                            <van-field v-model="form_data.mobile" type="tel" label="手机号码" placeholder="请输入手机号码"
                            required
                            :readonly="readonly"/>
                        </div>
                        <div class="from-item" v-if="!readonly">
                            <van-field
                            v-model="form_data.code"
                            required
                            center
                            label="短信验证码"
                            placeholder="请输入短信验证码"
                            >
                            <template #button>
                                <div class="u-btn sms" @click="get_code()">{{ sms ? '已发送('+ cnt_down +'秒)' : '获取验证码' }}</div>
                            </template>
                            </van-field>
                        </div>                      
                    </div>

                    <div class="uis flex-center-center" v-if="!(($store.state.userinfo.uflag & 256) == 256)">
                        <div class="u-btn review" @click="form_check()" v-if="!readonly"></div>
                        <div class="u-btn re" @click="readonly = false" v-if="readonly"></div>
                        <div class="u-btn submit" @click="submit()" v-if="readonly"></div>
                    </div>
                    <div class="uis flex-center-center" v-else>
                        <div class="u-btn ok" @click="closeModal"></div>
                    </div>                    
                    </van-form>

                    <div class="warn"><em class="icon sprite sprite-warn_modal"></em>请仔细确认个人信息（仅作红包发放之用，登记后隐藏敏感信息）,填写错误不可更改，不做补发</div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>

.ali-modal{
    width: 690px;
    height: 743px;
    background-image: url(~@/assets/images/modal/bg-modal-ali.png);

    &.comfirm{
        width: 690px;
        height: 513px;
        background-image: url(~@/assets/images/modal/bg-modal-ali_c.png);
    }

    &.complete{
        width: 690px;
        height: 693px;
        background-image: url(~@/assets/images/modal/bg-modal-complete.png);        
    }
}

.title{
    width: 586px;
    height: 49px;
    margin: 0 auto 20px;
    background-repeat : no-repeat;
    background-position : center;
    background-image: url(~@/assets/images/modal/title-ali.png);

    &.comfirm{
        width: 687px;
        height: 49px;
        margin: 0 auto 20px;
        background-repeat : no-repeat;
        background-position : center;
        background-image: url(~@/assets/images/modal/title-ali_c.png);        
    }
}

.comfirm-info{
    margin-top: 60px;
    margin-bottom: 80px;
    line-height: 1.8;
}

.notice{
    margin-bottom: 22px;
    font-size : 22px;
    color : #f8e1dc;
    text-align : center;
}

.form-view{
    margin-bottom: 15px;
    padding:  0 38px;
    // height: 420px;

    .from-item{
        // margin-bottom: 15px;
    }

    .attention{
        margin-left: 174px;
        width: 414px;
        text-align: center;
        font-size: 18px;
        color: #f8e1dc;
    } 
    
    .u-btn.sms{
        width: 161px;
        height: 66px;
        line-height: 66px;
        text-align: center;
        font-size: 22px;
        color: #fafcff;
        background-image: url(~@/assets/images/modal/btn-sms.png); 
    }
}

.complete .form-view{
    // height: 345px;
}

.warn{
    margin-top: 20px;
    padding: 0 62px;
    font-size: 20px;
    color: #ffb864;

    em{
        display: inline-block;
        vertical-align: middle;
        margin-right: 5px;
    }
}

.uis{
    padding: 0 38px;

    .u-btn{
        width: 255px;
        height: 83px;
        margin: 0 20px;
        background-repeat: no-repeat;

        &.cancel{
            background-image: url(~@/assets/images/modal/btn-cancel.png);
        }

        &.review{
            background-image: url(~@/assets/images/modal/btn-ali.png);
        }

        &.submit{
            background-image: url(~@/assets/images/modal/btn-ali.png);
        }
        
        &.re{
            background-image: url(~@/assets/images/modal/btn-cancel.png);
        }

         &.ok{
            background-image: url(~@/assets/images/modal/btn-ok.png);
        }       
    }
}

</style>

<style lang="scss">
.van-cell{
    align-items: center;
    background-color: transparent;
    padding: 4px 16px;
}

.van-field__label{
    font-size: 24px;
    color: #f8e1dc;
}

.van-field__body{
    width: 414px;
    height: 66px;
    line-height: 66px;
    font-size: 24px;
    color: #f8e1dc;
    background-color: #692824;
    border-radius: 14px;  
}

.van-field__control{
    text-align: center;
    font-size: 22px;
    color: #f8e1dc;
}
</style>

<script>
import { apiSms , apiAccountSubmit , apiAccountInfo } from '@/api/index';

const MOBILE_REG = /^1[3-9]\d{9}$/;
const ID_CARD_REG = /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/;
const ID_CARD_WEIGHTS = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
const ID_CARD_CODES = '10X98765432';

function isValidIdCard(idCard) {
    if(!ID_CARD_REG.test(idCard))return false;

    const year = Number(idCard.substr(6, 4));
    const month = Number(idCard.substr(10, 2));
    const day = Number(idCard.substr(12, 2));
    const date = new Date(year, month - 1, day);

    if(date.getFullYear() !== year || date.getMonth() + 1 !== month || date.getDate() !== day)return false;

    const sum = ID_CARD_WEIGHTS.reduce((total, weight, index) => total + Number(idCard[index]) * weight, 0);
    return ID_CARD_CODES[sum % 11] === idCard[17].toUpperCase();
}

export default {
    data () {
        return {
            visible : false,
            text : '',
            sms : false,
            cnt_down : 60,
            cnt_max : 60,
            readonly : false,
            form_data : {
                code:"",//有手机号需要填验证码
                realName: "",
                mobile: "",
                aliPayAccount: "",
                IdCard: ""
            },
            gacha_list : [],        
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
        this.$disableScroll();
    },
    mounted(){
        this.getAliInfo();
    },
    methods : {
        validateMobile(){
            const mobile = (this.form_data.mobile || '').trim();
            this.form_data.mobile = mobile;

            if(!mobile){
                this.$toast('请输入手机号码');
                return false;
            }
            if(!MOBILE_REG.test(mobile)){
                this.$toast('请输入正确的手机号码');
                return false;
            }
            return true;
        },
        validateIdCard(){
            const idCard = (this.form_data.IdCard || '').trim();
            this.form_data.IdCard = idCard;

            if(!idCard){
                this.$toast('请输入身份证号码');
                return false;
            }
            if(!isValidIdCard(idCard)){
                this.$toast('请输入正确的身份证号码');
                return false;
            }
            return true;
        },
        validateAliForm({ requireCode = true } = {}){
            if(!this.form_data.realName){
                this.$toast('请输入真实姓名');
                return false;
            }
            if(!this.form_data.aliPayAccount){
                this.$toast('请输入支付宝账号');
                return false;
            }
            if(!this.validateIdCard())return false;
            if(!this.validateMobile())return false;
            if(requireCode && !this.form_data.code){
                this.$toast('请输入手机验证码');
                return false;
            }
            return true;
        },
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$enableScroll();
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },
        getAliInfo(){
            apiAccountInfo().then(
                res => {
                    if(res.data.aliPayAccount){
                        this.form_data.realName = res.data.realName;
                        this.form_data.mobile = res.data.mobile;
                        this.form_data.aliPayAccount = res.data.aliPayAccount;
                        this.form_data.IdCard = res.data.idCard;
                        this.readonly = true; //已绑定
                    }
                }
            )
        },
        get_code(){

            let _this = this;

            if(!this.validateMobile())return;
            if(this.sms){
                return this.$toast('请稍等');
            }

            this.sms = true;
            this.cnt_down = 60;

            apiSms({mobile : this.form_data.mobile , type : 1}).then(
                res => {
                    this.$toast('验证码已发送，请注意查收');
                    --this.cnt_down;
                    this.timer = setInterval( ()=>{
                        if(_this.cnt_down <= 0){
                            _this.cnt_down = _this.cnt_max;
                            _this.sms = false;
                            return clearInterval(_this.timer);                
                        }
                        --_this.cnt_down;
                    } , 1000 );                      
                },
                rej => {
                    this.cnt_down = _this.cnt_max;
                    this.sms = false;
                    clearInterval(this.timer);

                    this.$toast(rej.msg || '获取验证码失败，请稍后再试');
                }
            )
        },
        form_check(){
            if(!this.validateAliForm())return;

            this.readonly = true;
        },
        submit (){
            let _this = this;

            if(!this.validateAliForm())return;

            apiAccountSubmit(this.form_data).then(
                res => {
                    this.$toast('信息提交成功');
                    this.closeModal();
                    //this.$store.dispatch('getUserInfo'); //重新获取用户信息
                    this.$update_evt();
                    //this.$opt_modal({ gacha_list : this.gacha_list });
                },
                rej => {
                    _this.readonly = false;

                    this.$msg_modal({ type : 'bind-error' , text : rej.message || '请稍后再试~'});
                }
            )
        },      
    },    
}
</script>